import { useContext, useEffect, useState } from 'react'

import { Box, Button, Card, CardContent, CardHeader, Divider } from '@material-ui/core'
// @ts-expect-error typing
import { GridAlignedCarousel, TypographicCard } from '@scoir/carousels'

import ContentManagementContext from '../../ContentManagementProvider/Context'
import EditHighlightsModal from './EditHighlightsModal'
import HighlightsEmptyState from './HighlightsEmptyState'

const { Carousel, CarouselBody, CarouselControls } = GridAlignedCarousel

type HighlightsProps = {
  canManageContent: boolean
}
const Highlights = ({ canManageContent }: HighlightsProps) => {
  const [open, setOpen] = useState(false)
  const {
    fetchHighlightsLoading,
    fetchHighlights,
    saveHighlights,
    highlights,
    saveHighlightsSucceeded,
    saveHighlightsError,
  } = useContext(ContentManagementContext)

  useEffect(() => {
    // Fetch Highlights on Load
    if (fetchHighlightsLoading) {
      fetchHighlights()
    }
  }, [fetchHighlights, fetchHighlightsLoading])

  useEffect(() => {
    // Fetch Highlights on Save
    if (saveHighlightsSucceeded) {
      fetchHighlights()
      setOpen(false)
    }
  }, [fetchHighlights, saveHighlightsSucceeded])

  const handleModal = () => {
    setOpen(!open)
  }
  const handleOnSave = (newHighlights: string[]) => {
    saveHighlights(newHighlights)
  }

  /** TODO: Loading State - Need Designs */
  if (fetchHighlightsLoading) return null

  return (
    <Card elevation={0}>
      <Carousel>
        <CardHeader
          title="Highlights"
          titleTypographyProps={{ variant: 'h6', component: 'h2' }}
          action={
            !highlights?.length ? null : (
              <Box
                mt={1}
                display="flex"
                gridGap={16}
              >
                {canManageContent && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleModal}
                  >
                    Edit Highlights
                  </Button>
                )}
                <CarouselControls />
              </Box>
            )
          }
        />
        <Divider />
        <CardContent>
          {!highlights?.length ? (
            <HighlightsEmptyState
              canManageContent={canManageContent}
              handleModal={handleModal}
            />
          ) : (
            <CarouselBody
              xs={9}
              sm={9}
              md={6}
              spacing={2}
              showPartials={{ md: true, sm: true, xs: true }}
            >
              {highlights.map((bullet: string, idx: number) => {
                return (
                  <TypographicCard
                    key={idx}
                    body={bullet}
                    index={idx}
                    minHeight="230px"
                  />
                )
              })}
            </CarouselBody>
          )}
        </CardContent>
      </Carousel>
      <EditHighlightsModal
        hasSaveError={saveHighlightsError}
        highlights={highlights}
        isOpen={open}
        onClose={handleModal}
        onSave={handleOnSave}
      />
    </Card>
  )
}

export default Highlights
